import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../landingpage/sections/Header';
import { LegalDoc } from './legalContent';

interface LegalLandingPageProps {
  doc: LegalDoc;
  footerLinks: { to: string; label: string }[];
}

const LegalLandingPage: React.FC<LegalLandingPageProps> = ({ doc, footerLinks }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-landingPageBG text-white">
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Header */}
        <h1 className="text-4xl font-bold mb-8 text-center text-white">{doc.title}</h1>

        {/* Content */}
        <div className="space-y-6 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl shadow-sm p-8">
          {doc.sections.map((section, i) => (
            <section key={i}>
              {section.heading && (
                <h2 className="text-2xl font-semibold mb-3 text-white">{section.heading}</h2>
              )}
              {section.paragraphs?.map((paragraph, j) => (
                <p
                  key={j}
                  className={`text-white/80 leading-relaxed whitespace-pre-line${j > 0 ? ' mt-4' : ''}`}
                >
                  {paragraph}
                </p>
              ))}
              {section.bullets && (
                <ul className="list-disc list-inside text-white/80 leading-relaxed space-y-2">
                  {section.bullets.map((bullet, j) => (
                    <li key={j}>{bullet}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>

        {/* Footer Links */}
        <div className="mt-8 text-center">
          <div className="flex justify-center space-x-6 text-sm">
            {footerLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-white/80 hover:text-white transition underline"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <Link
            to="/"
            className="inline-block mt-6 text-white/80 hover:text-white transition underline"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LegalLandingPage;
